(function ($) {
  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initFooterBrandsCarousel() {
    var root = document.querySelector("[data-footer-brands-carousel]");
    if (!root) return;

    var viewport = root.querySelector(".footer-brands-carousel__viewport");
    var brandsEl = root.querySelector(".footer-brands-carousel__mount .brands");
    var prevBtn = root.querySelector(".footer-brands-carousel__btn--prev");
    var nextBtn = root.querySelector(".footer-brands-carousel__btn--next");

    if (!viewport || !brandsEl || brandsEl.children.length === 0) return;

    var links = brandsEl.querySelectorAll("a");
    var autoTimer = null;
    var autoDisabled = false;
    var reduced = prefersReducedMotion();

    function scrollStep(direction) {
      var first = brandsEl.querySelector("a");
      var gap = 0;
      if (typeof window.getComputedStyle === "function") {
        var cs = window.getComputedStyle(brandsEl);
        var g = cs.columnGap || cs.gap || "0";
        gap = parseFloat(g, 10) || 0;
      }
      var itemW = first ? first.offsetWidth + gap : 160;
      var amount = Math.min(viewport.clientWidth * 0.45, Math.max(itemW * 2, 140));
      viewport.scrollBy({
        left: direction * amount,
        behavior: reduced ? "auto" : "smooth",
      });
    }

    function isAtEnd() {
      return viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 3;
    }

    function isAtStart() {
      return viewport.scrollLeft <= 3;
    }

    function updateArrowState() {
      if (!prevBtn || !nextBtn) return;
      var sw = viewport.scrollWidth > viewport.clientWidth + 6;
      prevBtn.disabled = !sw || isAtStart();
      nextBtn.disabled = !sw || isAtEnd();
      prevBtn.setAttribute("aria-disabled", prevBtn.disabled ? "true" : "false");
      nextBtn.setAttribute("aria-disabled", nextBtn.disabled ? "true" : "false");
    }

    function stopAutoScroll() {
      if (autoTimer) {
        clearInterval(autoTimer);
        autoTimer = null;
      }
    }

    function startAutoScroll() {
      stopAutoScroll();
      if (reduced || autoDisabled || viewport.scrollWidth <= viewport.clientWidth + 6)
        return;

      autoTimer = window.setInterval(function () {
        if (isAtEnd()) {
          viewport.scrollTo({
            left: 0,
            behavior: reduced ? "auto" : "smooth",
          });
        } else {
          scrollStep(1);
        }
      }, 4200);
    }

    function disableAutoScrollFromUser() {
      autoDisabled = true;
      stopAutoScroll();
      root.classList.add("footer-brands-carousel--manual");
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        disableAutoScrollFromUser();
        scrollStep(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        disableAutoScrollFromUser();
        scrollStep(1);
      });
    }

    viewport.addEventListener(
      "scroll",
      function () {
        window.requestAnimationFrame(updateArrowState);
      },
      { passive: true }
    );

    window.addEventListener("resize", function () {
      updateArrowState();
      if (!autoDisabled && !reduced) startAutoScroll();
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("footer-brands-carousel__logo--in");
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    links.forEach(function (link) {
      io.observe(link);
    });

    if (reduced) {
      links.forEach(function (link) {
        link.classList.add("footer-brands-carousel__logo--in");
      });
      root.classList.add("footer-brands-carousel--reduced-motion");
    }

    updateArrowState();
    startAutoScroll();
  }

  $(function () {
    initFooterBrandsCarousel();
  });
})(jQuery);
